import React, { createRef, FC, useEffect } from 'react'
import { debounce } from 'lodash'
import TextInput from '../../ui/form/TextInput'

import { tips } from '../locales'
import './styles.scss'

export interface AddressFilterInputProps {
  onChange: Function
}

const AddressFilterInput:FC<AddressFilterInputProps> = ({
  onChange
}) => {
  const ref = createRef<HTMLDivElement>();
  const handleInputChange = debounce((val) => {
    onChange && onChange(val)
  }, 200)

  useEffect(() => {
    const { current } = ref
    current && (current.onclick = (e) => {
      e.stopPropagation()
    })

    return () => {}
  })

  return (
    <div className="b3-address-search-container" ref={ref}>
      <TextInput 
        placeholder={tips['b3.addresses.search']}
        onChange={(e) => {
          handleInputChange(e.target.value)
        }}
      />
    </div>
  )
}

export default AddressFilterInput